var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_148_725",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0878906,
    y: 0.514526,
    width: 44.4476,
    height: 44.4476,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_148_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3118 15.8041L16.9588 10.4512L22.3118 5.11609L27.6825 10.4512L22.3118 15.8041ZM2.88379 36.9843V30.0394C2.88379 29.2512 3.15564 28.5763 3.69936 28.0148C4.24307 27.4532 4.89719 27.1606 5.66172 27.1368H11.7091C12.1982 27.1368 12.6672 27.2591 13.1159 27.5037C13.5647 27.7482 13.947 28.0842 14.2627 28.5116C15.1816 29.8436 16.3504 30.8734 17.769 31.6012C19.1877 32.3289 20.7019 32.6928 22.3118 32.6928C23.9216 32.6928 25.4388 32.3289 26.8634 31.6012C28.288 30.8734 29.4751 29.8436 30.4249 28.5116C30.7288 28.0842 31.0974 27.7482 31.5307 27.5037C31.964 27.2591 32.4252 27.1368 32.9144 27.1368H38.9618C39.7382 27.1606 40.3982 27.4532 40.9419 28.0148C41.4857 28.5763 41.7575 29.2512 41.7575 30.0394V36.9843H30.3964V31.6884C29.3089 32.6714 28.0742 33.4347 26.6924 33.9785C25.3105 34.5222 23.8503 34.794 22.3118 34.794C20.7969 34.794 19.3503 34.5251 17.972 33.9874C16.5938 33.4496 15.3514 32.6892 14.245 31.7062V36.9843H2.88379ZM8.03017 23.5575C6.73616 23.5575 5.62023 23.0886 4.68239 22.1507C3.74448 21.2129 3.27553 20.0969 3.27553 18.8029C3.27553 17.4781 3.74447 16.3544 4.68234 15.432C5.62019 14.5096 6.73612 14.0483 8.03013 14.0483C9.35501 14.0483 10.4787 14.5096 11.4011 15.432C12.3235 16.3544 12.7847 17.4781 12.7847 18.8029C12.7847 20.0969 12.3235 21.2129 11.4011 22.1507C10.4787 23.0886 9.35505 23.5575 8.03017 23.5575ZM36.5934 23.5575C35.2994 23.5575 34.1835 23.0886 33.2456 22.1507C32.3077 21.2129 31.8388 20.0969 31.8388 18.8029C31.8388 17.4781 32.3077 16.3544 33.2456 15.432C34.1835 14.5096 35.2994 14.0483 36.5934 14.0483C37.9183 14.0483 39.0419 14.5096 39.9644 15.432C40.8868 16.3544 41.348 17.4781 41.348 18.8029C41.348 20.0969 40.8868 21.2129 39.9644 22.1507C39.0419 23.0886 37.9183 23.5575 36.5934 23.5575Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerExchange);
export default __webpack_public_path__ + "static/media/partner_exchange.fadf5d175b2f7344c25bb55b29cfbb79.svg";
export { ForwardRef as ReactComponent };